import React from 'react';
import PropTypes from 'prop-types';
import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';
import { connect } from 'react-redux';
import { getResourceTo } from 'react/utils/chatUtils';

import BaseToast from './baseToast';
import SecondaryToast from './secondaryToast';

function DefaultToast({
  toastData,
  removeToast
}) {
  const variant = toastData.get('variant', 'default');

  function removeThisToast() {
    removeToast({ id: toastData.get('id') });
  }

  const header = () => (
    <>
      <h4>
        <span className={`${toastData.get('type', 'success')}-icon`} />
        {getResourceTo(toastData.getIn(['data', 'title']))}
      </h4>
      <span
        className="close-icon"
        onClick={removeThisToast}
        alt="Close Icon"
      />
    </>
  );

  const body = () => (
    <p>{toastData.getIn(['data', 'description'])}</p>
  );

  if (variant === 'secondary') {
    return (
      <SecondaryToast
        toastId={toastData.get('id')}
        type={toastData.get('type', 'success')}
        title={getResourceTo(toastData.getIn(['data', 'title']))}
        description={toastData.getIn(['data', 'description'])}
      />
    );
  }

  return (
    <BaseToast
      toastId={toastData.get('id')}
      className={`generic-toast ${toastData.get('type', 'success')}`}
      header={header()}
      body={body()}
      data-testid={`generic-toast-${toastData.get('type', 'success')}-${toastData.get('id')}`}
    />
  );
}

DefaultToast.propTypes = {
  toastData: PropTypes.object.isRequired,
  removeToast: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  removeToast: toastAlertsCreators.removeToast
};

export default connect(null, mapDispatchToProps)(DefaultToast);
